// frontend/src/components/profile/ProfileStatsCard.tsx

import { ProfileStats } from '../../types/profile.types';
import { BookOpen, CheckCircle, FolderGit2, Trophy } from 'lucide-react';

interface ProfileStatsCardProps {
  stats: ProfileStats;
}

export function ProfileStatsCard({ stats }: ProfileStatsCardProps) {
  const items = [
    {
      value: stats.completedLessons,
      label: 'Tamamlanan Ders',
      icon: <BookOpen size={24} color="#059669" />,
      colorClass: 'stat-green',
    },
    {
      value: stats.totalQuizzes,
      label: 'Çözülen Quiz',
      icon: <CheckCircle size={24} color="#0284c7" />,
      colorClass: 'stat-blue',
    },
    {
      value: stats.completedProjects,
      label: 'Yapılan Proje',
      icon: <FolderGit2 size={24} color="#d97706" />,
      colorClass: 'stat-yellow',
    },
    {
      value: stats.earnedBadges,
      label: 'Kazanılan Rozet',
      icon: <Trophy size={24} color="#9333ea" />,
      colorClass: 'stat-purple',
    },
  ];

  return (
    <div className="card profile-stats-wrapper-card" style={{ marginBottom: 24 }}>
      <h3 className="profile-section-title">📊 Öğrenme İstatistikleri</h3>
      <div className="profile-stats-grid">
        {items.map((item) => (
          <div className={`profile-stat-box ${item.colorClass}`} key={item.label}>
            <div className="profile-stat-icon-wrap">{item.icon}</div>
            <div className="profile-stat-value">{item.value}</div>
            <div className="profile-stat-label">{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
